import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAZ6tXudJ_aT5R7TCDqEe5UBa9kCYq8iaU",
  authDomain: "agoda-15583.firebaseapp.com",
  projectId: "agoda-15583",
  storageBucket: "agoda-15583.appspot.com",
  messagingSenderId: "101171146154",
  appId: "1:101171146154:web:9f9400d4eb07b43cd10fd3",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
